import {
  Component,
  HostListener,
  Input,
  OnInit,
} from '@angular/core';

import { AddAddressPage } from 'src/app/pages/add-address/add-address.page';
import { DataService } from 'src/app/services/data.service';

import {
  AlertController,
  ModalController,
} from '@ionic/angular';

@Component({
  selector: 'app-cus-address',
  templateUrl: './cus-address.component.html',
  styleUrls: ['./cus-address.component.scss'],
})
export class CusAddressComponent implements OnInit {

  @Input() customer_id: any;
  @Input() is_modal:any;
  is_address;
  selected_address: any = {};
  customer_name: any;

  constructor(public alertCtrl: AlertController,
    public db: DataService,
    public modalCtrl: ModalController,
  ) {

  }

  ngOnInit() {
    this.get_address();
    this.db.check_mobile();
  }


  @HostListener('window:resize', ['$event'])
  resize(event){
    let size = event.target.innerWidth;
      this.db.check_mobile();
  }

  async get_address() {
    let customerid;
    this.db.ismobile ? customerid = localStorage['cus_list'] : customerid =this.customer_id.name;
    this.db.domain_customer_Info(customerid).subscribe((res:any) => {
        this.db.address_list = res.message;
      },
      (error) => {
        console.log(JSON.stringify(error.json()));
      }
    );
  }

  async add_address() {
    let modal = await this.modalCtrl.create({
      component: AddAddressPage,
      cssClass: "address-popup",
      componentProps: {
        address_type: "Add",
        customer_id:this.customer_id
      },
    });
    await modal.present();
    let data = await modal.onWillDismiss();
    this.get_address();
  }

  dismiss_modal() {
    this.modalCtrl.dismiss();
  }

  async edit_address(li, index) {
    this.db.location_info.latitude = li.latitude ? li.latitude :''
    this.db.location_info.longitude = li.longitude ? li.longitude :''
    let modal = await this.modalCtrl.create({
      component: AddAddressPage,
      cssClass: "address-popup",
      componentProps: {
        address_type: "Edit",
        address_info: li,
        customer_data: this.customer_id
      },
    });
    await modal.present();
    let data = await modal.onWillDismiss();
      this.get_address();
  }

  select_address(addr) {
    this.modalCtrl.dismiss(addr);
  }

  deleteData(li, index) {
    this.delete_address(li, index);
  }

  delete_address(li, index) {
    // console.log(li)
    var data = {
      id: li.name,
      customer: this.customer_id.name,
    };
    this.db.delete_address(data,1).subscribe((res: any) => {
      console.log(res);
        this.db.address_list.splice(index, 1);
       if(li.name == this.db.customer_adr_id.name){
         this.db.customer_adr_id = undefined;
       }
        this.get_address();
      },
      (error) => {
        console.log(JSON.stringify(error.json()));
      }
    )
  }

  async confirm_delete(li, index) {
    let alert = await this.alertCtrl.create({
      header: 'Alert.!',
      message: 'Are you sure want to delete this address..?',
      buttons: [
        {
          text: 'Cancel',
          handler: () => { this.alertCtrl.dismiss() }
        },
        {
          text: 'yes',
          handler: () => {
            this.delete_address(li, index);
          }
        }
      ]

    })
    await alert.present();
  }

  select_customer(adr,i){
    if(this.is_modal){
      adr.count = i
      // console.log(adr);
      this.db.shipping_charge(adr);
      this.modalCtrl.dismiss(adr)
    }
  }

}

